import script from "./MitiFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MitiFooter.vue?vue&type=script&setup=true&lang=js"

import "./MitiFooter.vue?vue&type=style&index=0&id=c64fd418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64fd418"]])

export default __exports__